import client from "../apollo/apolloClient";
import API from "../axios";
import ApolloCampaign from "../apollo/apolloCampaign";

import { apiError } from "../observability/apiError";

export const getCampaigns = async (companyId) => {
  try {
    const response = await client.query({
      query: ApolloCampaign.GET_CAMPAIGNS,
      variables: { companyId },
    });
    return response.data;
  } catch (error) {
    throw apiError("ERROR_GETTING_CAMPAIGNS", error, {
      operation: "getCampaigns",
      module: "utils/campaign",
    });
  }
};

export const getCampaignsByChannelId = async (channelId) => {
  try {
    const response = await client.query({
      query: ApolloCampaign.GET_CAMPAIGNS_BY_CHANNEL_ID,
      variables: { channelId },
    });
    return response.data;
  } catch (error) {
    throw apiError("ERROR_GETTING_CAMPAIGNS", error, {
      operation: "getCampaignsByChannelId",
      module: "utils/campaign",
    });
  }
};

export const deleteCampaign = async (id) => {
  try {
    await client.query({
      query: ApolloCampaign.DELETE_CAMPAIGN,
      variables: { id },
    });
  } catch (error) {
    throw apiError("ERROR_DELETING_CAMPAIGNS", error, {
      operation: "deleteCampaign",
      module: "utils/campaign",
    });
  }
};

export const updateCampaignStatus = async (campaignId, status, sendAt) => {
  try {
    const response = await API.post(`/campaign/${campaignId}/status`, {
      status,
      ...(sendAt ? { sendAt } : {}),
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const rescheduleCampaign = async (campaignId, sendAt) => {
  try {
    const response = await API.post(`/campaign/${campaignId}/reschedule`, {
      sendAt,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
